<temptik-header></temptik-header>

<div>
  <router-outlet></router-outlet>
</div>
<div class="white-bg-color">
  <temptik-footer></temptik-footer>
</div>
